import React from 'react';

/**
 * Shared helper components for the quarterly report pages.
 */

/* ---- Paragraph renderer ---- */
export const TextWithParagraphs = ({ text, className = 'section-text' }) => {
  if (!text) return null;

  // If content contains HTML tags (from TipTap), render directly — unwrapping
  // any hyperlinks (pasted from Word/web before links were disabled) so report
  // text never carries clickable/styled anchors.
  if (/<[a-z][\s\S]*>/i.test(text)) {
    const clean = text.replace(/<a\b[^>]*>/gi, '').replace(/<\/a>/gi, '');
    return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
  }

  // Legacy plain-text fallback
  const paragraphs = text.split(/\n\n+/);
  return paragraphs.map((para, i) => (
    <p key={i} className={className}>
      {para.split('\n').map((line, j, arr) => (
        <React.Fragment key={j}>
          {line}
          {j < arr.length - 1 && <br />}
        </React.Fragment>
      ))}
    </p>
  ));
};

/* ---- Pull-quote gutter (left margin) ---- */
export const PullQuoteGutter = ({ callouts }) => {
  if (!callouts || callouts.length === 0) return null;
  return (
    <div className="qr-gutter">
      {callouts.map((c, i) => (
        <div
          key={i}
          className="qr-pull-quote"
          style={{ position: 'absolute', top: `${c.top || 0}mm` }}
        >
          {c.text}
        </div>
      ))}
    </div>
  );
};

/* ---- Footer ---- */
export const ReportFooter = ({ quarterDisplay, quarter, page }) => {
  const isMonthly = quarter && !quarter.includes('-Q');
  const label = isMonthly ? 'Investment Perspectives' : 'Quarterly Review';
  return (
    <footer className="qr-footer">
      <span className="qr-footer-left">{label} | {quarterDisplay}</span>
      <span className="qr-footer-right">Page {page}</span>
    </footer>
  );
};

/* ---- H1: uppercase with border-bottom rule ---- */
export const SectionHeadingH1 = ({ children }) => (
  <h2 className="qr-h1">{children}</h2>
);

/* ---- H2: bold, no border ---- */
export const SectionHeadingH2 = ({ children }) => (
  <h3 className="qr-h2">{children}</h3>
);

/* ---- Chart caption: small uppercase ---- */
export const ChartCaption = ({ children }) => (
  <p className="qr-chart-caption">{children}</p>
);
